import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-bond',
  templateUrl: './bond.component.html',
  styleUrls: ['./bond.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BondComponent implements OnInit {

  public searchText: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  Status: boolean = false;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownPort: Boolean = true;
  Type: string;
  port: string;
  bondNum: string;
  bondDate: string;
  bondvalue: string;
  validfrom: string;
  validTo: string;
  BondExport = [] as any;
  EditedBond = [] as any;
  EditedBondId: string;
  Ports = [];
  portid: string;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;

  displayedColumns: string[] = ['sno', 'bondType', 'port', 'bondnumber', 'bonddate1', 'bondvalue', 'validFrom1', 'validTo1', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('BondRead');
    this.vWrite = localStorage.getItem('BondWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
    }
    this.BindPortDDL();
    this.BindBondGrid();
    this.BindBondExport();
  }

  Show(event) {
    debugger;
    if (event.target.selectedIndex == 1) {
      this.isShownPort = false;
    }
    else {
      this.isShownPort = true;
    }

  }


  Check(event: any) {
    var vportname = this.port;
    debugger;
    let params = new HttpParams();
    params = params.append('dprtname', vportname);
    var value = this.http.get(environment.apiUrl + 'Bond/CheckPortName', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 =="") {
          this.isShownError = false;
          this.ErrorMsg = "Port Name doesn't exists. Please select a Valid Port Name from the list.";
          this.port = "";
          return false;
        }
        else {
          this.isShownError=true;
        }   
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 == "") {
          this.isShownError = false;
          this.ErrorMsg = "Port Name doesn't exists. Please select a Valid Port Name from the list."
          this.port="";
          return false;
        }
        else {
         this.isShownError=true;
        }   
      });
  }

  BindPortDDL() {
    var value = this.http.get(environment.apiUrl + 'Bond/GetPortDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.Ports = data;
          this.portid = "0";
        }
        else {
        };
      });
  }

  SubmitBond() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vtype = this.Type;
    var vport = this.port;
    var vbondnum = this.bondNum;
    var vbondDate = this.bondDate;
    var vbondvalue = this.bondvalue;
    var vvalidfrom = this.validfrom;
    var vvalidto = this.validTo;
    debugger;


    if (vtype == undefined || vtype == "" || vtype == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Type.";
      return false;
    }

    if (vtype == "RE") {
      if (vport == undefined || vport == "" || vport == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Select Port.";
        return false;
      }
    }


    if (vbondnum == undefined || vbondnum == "" || vbondnum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Bond Number.";
      return false;
    }

    if (vbondDate == undefined || vbondDate == "" || vbondDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Bond Date.";
      return false;
    }

    if (vbondvalue == undefined || vbondvalue == "" || vbondvalue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Value.";
      return false;
    }

    if (vvalidfrom == undefined || vvalidfrom == "" || vvalidfrom == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid From Date.";
      return false;
    }

    if (vvalidto == undefined || vvalidto == "" || vvalidto == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid To Date.";
      return false;
    }

    var vFrom1 = new Date(vvalidfrom);
    var vTo1 = new Date(vvalidto);

    if ((vTo1) < (vFrom1)) {
      this.isShownError = false;
      this.ErrorMsg = "End date should be greater then Valid From date.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dType', this.Type);
    params = params.append('dport', this.port);
    params = params.append('dbondNum', this.bondNum);
    params = params.append('dbondDate', this.bondDate);
    params = params.append('dbondvalue', this.bondvalue);
    params = params.append('dvalidfrom', this.validfrom);
    params = params.append('dvalidTo', this.validTo);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Bond/Insertbond', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencycode = data;
        this.Type = "";
        this.port = "";
        this.bondNum = "";
        this.bondDate = "";
        this.bondvalue = "";
        this.validfrom = "";
        this.validTo = "";
        this.SuccessMsg = "Bond Master Added."
        this.BindBondExport();
        this.BindBondGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Bond Number Already Exist";
          return false;
        }
        else {
        }
      });
  }

  EditBond(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedBond = item;
    var vbondid = this.EditedBond.bondid;
    var vtype = this.EditedBond.bondType;
    var vport = this.EditedBond.port;
    var vbondnum = this.EditedBond.bondnumber;
    var vbonddate = this.EditedBond.bonddate;
    var vvalidFrom = this.EditedBond.validFrom;
    var vvalidTo = this.EditedBond.validTo;
    var vbondvalue = this.EditedBond.bondvalue;

    this.EditedBondId = vbondid;
    this.Type = vtype;
    if (vtype == "RE") {
      this.isShownPort = false;
    }
    else {
      this.isShownPort = true;
    }
    this.port = vport;
    this.bondNum = vbondnum;
    this.bondvalue = vbondvalue;
    this.bondDate = new Date(new Date(vbonddate).setDate(new Date(vbonddate).getDate() + 1)).toISOString().split('T')[0];
    this.validfrom = new Date(new Date(vvalidFrom).setDate(new Date(vvalidFrom).getDate() + 1)).toISOString().split('T')[0];
    this.validTo = new Date(new Date(vvalidTo).setDate(new Date(vvalidTo).getDate() + 1)).toISOString().split('T')[0];
    var vStatus = this.EditedBond.status;
    debugger;
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }

  }


  UpdateBond() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownActive = false;
    var vtype = this.Type;
    var vport = this.port;
    var vbondnum = this.bondNum;
    var vbondDate = this.bondDate;
    var vbondvalue = this.bondvalue;
    var vvalidfrom = this.validfrom;
    var vvalidto = this.validTo;


    if (vtype == undefined || vtype == "" || vtype == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Type.";
      return false;
    }

    if (vtype == "RE") {
      if (vport == undefined || vport == "" || vport == "0") {
        this.isShownError = false;
        this.ErrorMsg = "Please Select Port.";
        return false;
      }
    }

    if (vbondnum == undefined || vbondnum == "" || vbondnum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Bond Number.";
      return false;
    }

    if (vbondDate == undefined || vbondDate == "" || vbondDate == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Bond Date.";
      return false;
    }

    if (vbondvalue == undefined || vbondvalue == "" || vbondvalue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Value.";
      return false;
    }

    if (vvalidfrom == undefined || vvalidfrom == "" || vvalidfrom == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid From Date.";
      return false;
    }

    if (vvalidto == undefined || vvalidto == "" || vvalidto == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Valid To Date.";
      return false;
    }
    var vFrom1 = new Date(vvalidfrom);
    var vTo1 = new Date(vvalidto);

    if ((vTo1) < (vFrom1)) {
      this.isShownError = false;
      this.ErrorMsg = "End date should be greater then Valid From date.";
      return false;
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";


    let params = new HttpParams();
    params = params.append('ibondid', this.EditedBondId);
    params = params.append('iType', this.Type);
    params = params.append('iport', this.port);
    params = params.append('ibondNum', this.bondNum);
    params = params.append('ibondDate', this.bondDate);
    params = params.append('ibondvalue', this.bondvalue);
    params = params.append('ivalidfrom', this.validfrom);
    params = params.append('ivalidTo', this.validTo);
    params = params.append('istatus', vStatus);
    
    var value = this.http.get(environment.apiUrl + 'Bond/UpdateBond', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencycode = data;
        this.Type = "";
        this.port = "";
        this.bondNum = "";
        this.bondDate = "";
        this.bondvalue = "";
        this.validfrom = "";
        this.validTo = "";
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn = true;
        this.isShownActive = true;
        this.SuccessMsg = "Bond Master Updated."
        this.BindBondExport();
        this.BindBondGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }

  ClearBond() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownPort = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.Type = "";
    this.port = "";
    this.bondNum = "";
    this.bondDate = "";
    this.bondvalue = "";
    this.validfrom = "";
    this.validTo = "";

  }


  BindBondGrid() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Bond/GetBondForGrid',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindBondExport() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'Bond/GetBondForExport',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.BondExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.BondExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'BondMaster');

    /* save to file */
    XLSX.writeFile(wb, "BondMaster.xlsx");

  }

}
